import React, { useCallback, useContext } from 'react';
import { Tab } from 'semantic-ui-react';
import { OperationsContext } from '../OperationsContext';
import PlanSummary from './PlanSummary';

const PlanSummaryTab = () => {
	const { renewalClient } = useContext( OperationsContext );

	const mapPlans = useCallback( () => renewalClient?.currentBenefit.medical.plans.map( ( plan, i ) => (
		<PlanSummary
			key={ plan.id }
			currentPlan={ plan }
			pastPlan={ renewalClient?.pastBenefit.medical.plans[ i ]}
			year={ renewalClient?.renewal.year }
		/>
	) ), [ renewalClient ] );

	return (
		<Tab.Pane as="div">
			{ mapPlans() }
		</Tab.Pane>
	);
};

export default PlanSummaryTab;
